import { IFilters } from '../../utils/component/base-filter-component/IFilter';
import { ModuleJsonModel } from '../module.json.model';

export namespace ModuleActions {
  export class Add {
    static readonly type = getActionName('Add Module');

    constructor(
      public payload: ModuleJsonModel,
      public filters?: IFilters
    ) {}
  }

  export class Edit {
    static readonly type = getActionName('Edit Module');

    constructor(
      public payload: ModuleJsonModel,
      public filters?: IFilters
    ) {}
  }

  export class Delete {
    static readonly type = getActionName('Delete');

    constructor(readonly payload: ModuleJsonModel) {
    }
  }

  export class Fetch {
    static readonly type = getActionName('Fetch');

    public include: string;
    public overrideOptions?: {
      pageNumber?: number
      pageSize?: number
      skipStoreDispatch?: boolean
    };

    constructor(
      include?: string,
      overrideOptions?: {
        pageNumber?: number
        pageSize?: number
        skipStoreDispatch?: boolean
      }
    ) {
      this.include = include === undefined ?
        'consumer,subjects,learningUnits,schoolClasses' :
        include;

      this.overrideOptions = overrideOptions;
    }
  }

  export class FetchAll {
    static readonly type = getActionName('Fetch all');
  }

  export class FetchAppend {
    static readonly type = getActionName('Fetch and append');

    public include: string;
    public overrideOptions?: {
      pageNumber?: number
      pageSize?: number
      skipStoreDispatch?: boolean
    };

    constructor(
      include?: string,
      overrideOptions?: {
        pageNumber?: number
        pageSize?: number
        skipStoreDispatch?: boolean
      }
    ) {
      this.include = include === undefined ?
        'consumer,subjects,learningUnits,schoolClasses' :
        include;

      this.overrideOptions = overrideOptions;
    }
  }

  export class FetchSuccess {
    static readonly type = getActionName('Fetch success');

    constructor(readonly payload: ModuleJsonModel[]) {
    }
  }

  export class FetchSuccessAppend {
    static readonly type = getActionName('Fetch success append');

    constructor(readonly payload: ModuleJsonModel[]) {
    }
  }

  export class FetchWithFilters {
    static readonly type = getActionName('Fetch with filters');
    constructor(readonly filters: IFilters) { }
  }

  function getActionName(type: string) {
    return `[Module] ${type}`;
  }
}
